import { render } from "./SubmitRequestPage.vue?vue&type=template&id=3a454b8c&scoped=true"
import script from "./SubmitRequestPage.vue?vue&type=script&lang=js"
export * from "./SubmitRequestPage.vue?vue&type=script&lang=js"

import "./SubmitRequestPage.vue?vue&type=style&index=0&id=3a454b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a454b8c"]])

export default __exports__